import { render, staticRenderFns } from "./LanguageSwitch.vue?vue&type=template&id=74e417c0&scoped=true"
import script from "./LanguageSwitch.vue?vue&type=script&lang=js"
export * from "./LanguageSwitch.vue?vue&type=script&lang=js"
import style0 from "./LanguageSwitch.vue?vue&type=style&index=0&id=74e417c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74e417c0",
  null
  
)

export default component.exports